export default function filterEligibleDistributionChannels({ channels, article }) {
	return (
		channels?.filter(
			({ active, acceptedLanguages, acceptedArticleTypes }) =>
				active &&
				(acceptedArticleTypes?.length === 0 || acceptedArticleTypes?.includes(article.type)) &&
				(acceptedLanguages?.length === 0 || acceptedLanguages?.includes(article.language)),
		) || []
	);
}
